


























import { Component, Vue, Watch } from "vue-property-decorator";
import MonitoringsService, { HardwareMonitoring, SocketChannels } from "./service";
import { DxScrollView, DxTextBox } from "devextreme-vue";
import { alert, confirm } from "devextreme/ui/dialog";
import AuthService from "@/services/auth_service";
import _ from "lodash";
import Moment from "moment";
import Highcharts from "highcharts";
import highChartSettings from "@/services/highchat_service";
import notifyService from "@/services/notify_service";

import base_ds from "@/services/base_datasource_service";
import WebSocketService from "@/services/websocket_service";

Highcharts.setOptions({
  time: {
    timezoneOffset: -Moment().utcOffset(),
  },
  lang: highChartSettings.lang,
});

@Component({
  name: "HardwareMonitoring",
  components: {
    DxTextBox,
    DxScrollView,
  },
})
export default class extends Vue {
  public service = MonitoringsService;

  // Инстансы отображаемых графиков
  public metricChartInstances: any[] = [];
  // Массив начальных настроек графиков
  public chartOptions: any[] = [];

  private hardware_metrics = [
    {
      key: "cpu_usage",
      caption: "Загрузка процессора",
    },
    {
      key: "free_memory",
      caption: "Свободная оперативная память",
    },
    {
      key: "free_disk",
      caption: "Свободное место на диске",
    },
  ];

  created() {
    if (this.$options.sockets) {
      this.$options.sockets.onmessage = (data: any) => {

        let res = WebSocketService.handleMsg(data, SocketChannels.hardware_metrics);
        if (!_.isNil(res)) {
          setTimeout(() => {

            // добавление новых метрик на графики
            this.hardware_metrics.forEach((hm, index) => {
              if (
                this.metricChartInstances.length > index &&
                this.metricChartInstances[index].series.length
              ) {
                this.metricChartInstances[index].series[0].addPoint([
                  new Date().valueOf(),
                  res[hm.key],
                ]);
              }
            });

          }, 1000);

        }
      }
    }

    this.load_hardware_metric();
  }

  async load_hardware_metric() {
    const hardwareMetricsData: any = {
      cpu_usage: [],
      free_memory: [],
      free_disk: [],
    };

    const resp = await this.service.getHardwareMonitoring();

    if (resp?.data) {
      resp.data.forEach((x: HardwareMonitoring) => {
        if (x.date_created) {
          let dateValue: number = new Date(x.date_created).valueOf();
          hardwareMetricsData.cpu_usage.push([dateValue, x.cpu_usage]);
          hardwareMetricsData.free_memory.push([dateValue, x.free_memory]);
          hardwareMetricsData.free_disk.push([dateValue, x.free_disk]);
        }
      });
    } else if (resp?.message) {
      notifyService.error(
        `Ошибка при загрузке метрик устройства: ${resp.message}`
      );
      return;
    }

    // Установка высоты одного графика: половина высоты рабочей области но не менее 300 пикс
    let chartHeight = 300;
    const h: any = document.getElementById("self-monitoring-content");
    if (h) {
      let hClalculated = (h.offsetHeight - 40) / 2;
      if (hClalculated > chartHeight) {
        chartHeight = hClalculated;
      }
    }

    // Заполнение массива превоначального состяния графиков
    this.chartOptions = this.hardware_metrics.map((hm) => {
      const data = hardwareMetricsData[hm.key];

      let chartObj: any = _.cloneDeep(highChartSettings.defaultOptions);
      chartObj.chart.height = `${chartHeight}`;
      chartObj.title.text = hm.caption;
      chartObj.yAxis = [{ labels: { format: "{value}" + "%" } }];
      chartObj.series[0].data = data;

      // Нормировать график по оси Y
      let leftXVal: number;
      let rightXVal: number;
      if (data.length) {
        leftXVal = data[0][0];
        rightXVal = data[data.length - 1][0];
      } else {
        leftXVal = new Date().valueOf();
        rightXVal = leftXVal - 3600;
      }

      // массив точек "невидимого" графика
      let empty: Array<[number, number]> = [];
      // граничные значение отображения в диапазоне 0 до 100 %
      empty.push([leftXVal, 100], [rightXVal, 100]);
      empty.push([leftXVal, 0], [rightXVal, 0]);
      const seriesObj = {
        showInLegend: false,
        type: "scatter",
        marker: {
          enabled: false,
        },
        enableMouseTracking: false,
        data: empty,
      };
      chartObj.series[1] = seriesObj;

      return chartObj;
    });
  }

  private onSaveChartInstance(chart: any) {
    this.metricChartInstances.push(chart);
  }


  mounted() {

  }

  destroyed() {
    if (this.$options.sockets) {
      delete this.$options.sockets.onmessage
    }
  }



  empty() {
    //
  }

  onClose() {

  }

}
